import React, { useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import $ from "jquery";
import "datatables.net-dt/js/dataTables.dataTables.js";
import "datatables.net-responsive-dt/js/responsive.dataTables.js";
import "datatables.net-responsive-dt/css/responsive.dataTables.css";
import { API_URL } from "..";

const ExpensesListLayer = ({ expensesData = [] }) => {
  const tableRef = useRef(null);
  const history = useNavigate();

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this expense?")) return;

    try {
      const res = await fetch(`${API_URL}/api/expenses/${id}`, {
        method: "DELETE",
      });

      if (res.ok) {
        window.location.reload();
      } else {
        alert("Error deleting expense");
      }
    } catch (err) {
      alert("Error deleting: " + err.message);
    }
  };

  useEffect(() => {
    if ($.fn.DataTable.isDataTable("#expensesTable")) {
      $("#expensesTable").DataTable().destroy(true);
    }

    tableRef.current = $("#expensesTable").DataTable({
      data: expensesData,
      responsive: true,
      pageLength: 10,

      columns: [
        { data: "expense_title", title: "Title" },
        {
          data: "expense_amount",
          title: "Amount",
          render: (amt) => `Rs. ${Number(amt).toLocaleString()}`,
        },
        { data: "expense_date", title: "Date" },
      {
        data: "ExpenseCategory",
        title: "Category",
        className: "cat-col",
        render: (cat) => cat?.title || "N/A",
      },

        // {
        //   data: "notes",
        //   title: "Notes",
        //   render: (n) => (n ? n.substring(0, 40) + "..." : "—"),
        // },
        {
          data: null,
          title: "Actions",
          orderable: false,
          render: (data, type, row) => `
            <div class="dropdown">
              <button class="dropdown-toggle" data-bs-toggle="dropdown">
                <i class="ph ph-list"></i>
              </button>
              <ul class="dropdown-menu">
                <li><a class="dropdown-item view-btn" data-id="${row.id}">
                  <i class="ph ph-eye"></i> View
                </a></li>
                <li><a class="dropdown-item edit-btn" data-id="${row.id}">
                  <i class="ph ph-pencil"></i> Edit
                </a></li>
                <li><a class="dropdown-item delete-btn" data-id="${row.id}">
                  <i class="ph ph-trash"></i> Delete
                </a></li>
              </ul>
            </div>
          `,
        },
      ],
    });

    $("#expensesTable tbody").on("click", ".view-btn", function () {
      const id = $(this).data("id");
      history(`/view-expense/${id}`);
    });

    $("#expensesTable tbody").on("click", ".edit-btn", function () {
      const id = $(this).data("id");
      history(`/edit-expense/${id}`);
    });

    $("#expensesTable tbody").on("click", ".delete-btn", function () {
      const id = $(this).data("id");
      handleDelete(id);
    });

    return () => {
      if ($.fn.DataTable.isDataTable("#expensesTable")) {
        $("#expensesTable").DataTable().destroy(true);
      }
    };
  }, [expensesData]);

  return (
    <>
      {/* INLINE CSS INSIDE COMPONENT */}
      <style>
        {`
          .cat-col {
            max-width: 240px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            display: block;
          }
        `}
      </style>

      <div className="card basic-data-table">
        <div className="card-header">
          <div className="row">
            <h5 className="col-md-6 card-title mb-0">All Expenses</h5>

            <div className="col-md-6 text-end">
              <Link className="btn btn-info" to="/addexpense">
                Add New Expense
              </Link>
            </div>
          </div>
        </div>

        <div className="card-body">
          <table className="table bordered-table mb-0" id="expensesTable"></table>
        </div>
      </div>
    </>
  );
};

export default ExpensesListLayer;
